import { buildSurveySubmitPayload } from "containers/Payment/services/buildPayload"
import { Answer, Question } from "containers/Survey/types"
import { CallRequest } from "types/payload"
import { Action } from "types/redux"

import { TELEEXPERTISE_CREATE_REQUEST } from "./constants"

export interface TeleexpertiseCreatePayload extends CallRequest {
  patient_consent: boolean
  pharmacist_consent: boolean
}

const actions = {
  create: (
    answers: Answer[],
    questions: Question[],
    patientConsent: boolean,
    pharmacistConsent: boolean,
    dermatoPatientDetails: string | null,
  ): Action<TeleexpertiseCreatePayload> => ({
    type: TELEEXPERTISE_CREATE_REQUEST,
    payload: {
      ...buildSurveySubmitPayload(answers, questions, { dermatoPatientDetails }),
      patient_consent: patientConsent,
      pharmacist_consent: pharmacistConsent,
    },
  }),
}

export default actions
